var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg008Bluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9999 8.05005C19.0159 7.73526 18.8824 7.43137 18.6399 7.23005L12.6399 2.23005C12.3416 1.98156 11.9264 1.92822 11.5749 2.09323C11.2235 2.25825 10.9993 2.61178 10.9999 3.00005V10.1301L6.54991 7.13005C6.25439 6.892 5.84958 6.84174 5.50481 7.00029C5.16004 7.15883 4.93471 7.49887 4.92308 7.87817C4.91145 8.25747 5.11551 8.61067 5.44991 8.79005L10.1999 12.0001L5.44991 15.1701C5.11551 15.3494 4.91145 15.7026 4.92308 16.0819C4.93471 16.4612 5.16004 16.8013 5.50481 16.9598C5.84958 17.1184 6.25439 17.0681 6.54991 16.8301L10.9999 13.8301V21.0001C10.9989 21.3906 11.2255 21.746 11.5799 21.9101C11.7117 21.9701 11.855 22.0008 11.9999 22.0001C12.2336 22.0005 12.46 21.9191 12.6399 21.7701L18.6399 16.7701C18.8685 16.5797 19.0004 16.2975 18.9999 16.0001C18.9821 15.6834 18.8151 15.394 18.5499 15.2201L13.7999 12.0001L18.5499 8.83005C18.8151 8.65612 18.9821 8.3667 18.9999 8.05005ZM16.3299 16.0501L12.9999 18.8601V13.8601L16.3299 16.0501ZM12.9999 10.0501V5.05005L16.3299 7.82005L12.9999 10.0501Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg008Bluetooth);
export default __webpack_public_path__ + "static/media/008-bluetooth.9a729f3d946ab1e3efbd54ed2da1af29.svg";
export { ForwardRef as ReactComponent };